<div
  class="title-card border-gray-bottom border-gray-top flex-row flex--align-center padding-standard-inline background-white"
>
  <h4 class="title-header margin-none  mat-headline-4">
    {{ titleSubject | async }}
  </h4>
</div>
